var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2689 5.3818H20.5C20.5 1.98459 18.4644 0 15.0156 0H5.98444C2.53556 0 0.5 1.98459 0.5 5.33847V12.6615C0.5 16.0154 2.53556 18 5.98444 18H15.0156C18.4644 18 20.5 16.0154 20.5 12.6615V12.3495H16.2689C14.3052 12.3495 12.7133 10.7975 12.7133 8.883C12.7133 6.96849 14.3052 5.41647 16.2689 5.41647V5.3818ZM16.2686 6.87241H19.753C20.1654 6.87241 20.4997 7.19834 20.4997 7.60038V10.131C20.4949 10.5311 20.1634 10.8542 19.753 10.8589H16.3486C15.3545 10.872 14.4852 10.2084 14.2597 9.26432C14.1468 8.67829 14.3053 8.07356 14.6927 7.61222C15.0802 7.15087 15.657 6.88007 16.2686 6.87241ZM16.4209 9.533H16.7498C17.172 9.533 17.5143 9.19931 17.5143 8.78769C17.5143 8.37607 17.172 8.04239 16.7498 8.04239H16.4209C16.219 8.04007 16.0245 8.11666 15.8809 8.25505C15.7373 8.39345 15.6565 8.58215 15.6565 8.77903C15.6564 9.19207 15.9973 9.52825 16.4209 9.533ZM5.23848 5.38181H10.8829C11.3051 5.38181 11.6474 5.04812 11.6474 4.6365C11.6474 4.22488 11.3051 3.8912 10.8829 3.8912H5.23848C4.81973 3.89117 4.4789 4.2196 4.47403 4.62784C4.474 5.04088 4.81485 5.37706 5.23848 5.38181Z",
    fill: "#9983FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.90576aba6021bf9bd2f596ce9bdc408c.svg";
export { ForwardRef as ReactComponent };